function homepage() {
	const mainHomepage = document.querySelector('main.homepage');
	if (!mainHomepage) return;

	document.querySelectorAll('.swiper.products')?.forEach((swiperContainer) => {
		new Swiper(swiperContainer, {
			slidesPerView: 1.5,
			spaceBetween: 40,
			autoplay: {
				delay: 5000,
			},
			loop: true,
			navigation: {
				nextEl: '.button-next',
				prevEl: '.button-prev',
			},
			breakpoints: {
				1200: {
					slidesPerView: 4.5,
				},
				991: {
					slidesPerView: 3.5,
				},
				768: {
					slidesPerView: 2.5,
				},
			},
		});
	});

	document.querySelectorAll('.swiper.images')?.forEach((swiperContainer) => {
		new Swiper(swiperContainer, {
			slidesPerView: 1,
			navigation: {
				nextEl: '.button-next',
				prevEl: '.button-prev',
			},
			autoplay: {
				delay: 5000,
			},
			loop: true,
		});
	});

	document.querySelectorAll('.swiper.logos')?.forEach((swiperContainer) => {
		new Swiper(swiperContainer, {
			slidesPerView: 1,
			loopedSlides: 6,
			spaceBetween: 100,
			autoplay: {
				delay: 4500,
			},
			centeredSlides: true,
			loop: true,
			breakpoints: {
				1200: {
					slidesPerView: 4,
				},
				991: {
					slidesPerView: 3,
				},
				525: {
					slidesPerView: 2,
				},
			},
		});
	});
}
